import { variables, $ } from '../common/variables';
import { cl, ajax } from '../common/functions';
import { fieldDelete } from './field-delete';
import { fieldEdit } from './field-edit';
import { toggleEntities } from './toggle-entities';

const fieldCreateUtilities = () => {
  //Variables
  const $addressField = $('#idaddresse');
  const idaddresse = document.getElementById('idaddresse');
  const $longitudeField = $('#longitude');
  const $latitudeField = $('#latitude');

  /*------------ [JQUERY UI] ------------*/
  //Autocomplete
  $addressField.autocomplete({
    source: (request, response) => {
      $.ajax({
        url: 'https://api-adresse.data.gouv.fr/search/?q={s}', // France only
        // url: 'https://nominatim.openstreetmap.org/search?format=json&q={s}',
        data: { q: request.term },
        dataType: 'json',
        success: res => {
          response(
            $.map(res.features, item => {
              return {
                label: item.properties.label,
                latitude: item.geometry.coordinates[1],
                longitude: item.geometry.coordinates[0]
              };
            })
            // $.map(res, item => {
            //   return {
            //     label: item.display_name,
            //     latitude: item.lat,
            //     longitude: item.lon
            //   };
            // })
          );
        }
      });
    },
    //remplis les champs avec les values retournées
    select: (event, e) => {
      $addressField.val(e.item.label);
      $latitudeField.val(e.item.latitude);
      $longitudeField.val(e.item.longitude);
    }
  });

  /*------------ [LEAFLET] ------------*/
  //Check si le container de la map a déjà été initialisé
  if (document.getElementById("mapid")) {
    const container = L.DomUtil.get('mapid');
    if (container) {
      container._leaflet_id = container._leaflet_id ? null : null;
    }
    //Creation de la map
    const map = L.map('mapid', {
      gestureHandling: true
    });
    const osmUrl = 'https://stamen-tiles-{s}.a.ssl.fastly.net/toner-lite/{z}/{x}/{y}{r}.png';
    const osmAttrib = 'Map data © OpenStreetMap contributors';
    const osm = new L.TileLayer(osmUrl, { attribution: osmAttrib });
    map.addLayer(osm);

    //Change la view de la map en fonction du champ address
    idaddresse.onchange = () => {
      const latitude = $latitudeField.val();
      const longitude = $longitudeField.val();
      const marker = L.marker([latitude, longitude], {
        draggable: true,
        autoPan: true
      });
      marker.addTo(map);
      const latLngs = [marker.getLatLng()];
      const markerBounds = L.latLngBounds(latLngs);
      map.fitBounds(markerBounds);
      //drag le marker si besoin et renplace les nouvelles coordonnées
      marker.on('dragend', e => {
        const position = marker.getLatLng();
        $latitudeField.val(position.lat);
        $longitudeField.val(position.lng);
      });
    };

    // Get all options within <select id='foo'>...</select>
    const chainedSelect = (select1, select2) => {
      const firstSelect = document.getElementById(select1);
      const secondSelect = document.getElementById(select2);
      if (firstSelect !== null && secondSelect !== null) {
        // prettier-ignore
        firstSelect.addEventListener('change', e => {
          const option = secondSelect.getElementsByTagName('option');
          for (let i = 0; i < option.length; i++) {
            option[i].value === firstSelect.value ? (option[i].disabled = true) : (option[i].disabled = false);
          }
        }, false);
      }
    };
    chainedSelect('type', 'secondary_type');
    chainedSelect('secondary_type', 'type');
  }
}

const fieldCreate = () => {
  /*------------ [AJAX] function------------*/
  const action = 'create_fields_ajax';

  /*------------ [AJAX] success------------*/
  const success = (data) => {
    const notyf = new Notyf();
    if (!data.exist) {
      if (data.success) {
        notyf.success('Field successfully inserted');
        if (data.table === `${variables.prefix}gl_categories_types`) {
          const container = document.querySelector("#category-types__container hr");
          if (container) {
            const htmlElement = /*html*/ `
              <div class="row align-items-center justify-content-center section-manage">
                  <div class="col-md-4">
                      <div class="input-box">
                          <input
                            class="input-box__input ajax__edit gl__name"
                            type="text"
                            placeholder="Nom"
                            id="category__name--${data.id}"
                            data-id="${data.id}"
                            data-table="${data.table}"
                            data-fieldname="name"
                            data-name="${data.name}"
                            value="${data.name}"
                          >
                          <label class="input-box__label" for="category__name--${data.id}">Nom</label>
                      </div>
                  </div>
                  <div class="col-md-3 d-flex justify-content-center">
                      <a
                        class="gl__action gl__action--delete"
                        data-id="${data.id}"
                        data-name="${data.name}"
                        data-table="${data.table}"
                        data-prefix="${variables.prefix}"
                        href="#"
                      ></a>
                  </div>
              </div>
            `;
            container.insertAdjacentHTML('beforebegin', htmlElement);

            const inputsAdded = document.querySelectorAll(`#category__name--${data.id}`);
            !!inputsAdded.length && fieldEdit(inputsAdded);

            const deleteBtnAdded = document.querySelectorAll(`.gl__action--delete[data-id="${data.id}"][data-table="${data.table}"]`);
            !!deleteBtnAdded.length && fieldDelete(deleteBtnAdded);
          }
        } else if (data.table === `${variables.prefix}gl_types`) {
          const container = document.querySelector("#types__container hr");
          if (container) {

            let categorySelectElement = ``;
            !!data.category_types.length && [...data.category_types].forEach(category => {
              categorySelectElement += /*html*/ `
                <option
                  value="${category.id}"
                  ${category.id === data.category_id ? 'selected="selected"' : ''}
                >
                  ${category.name}
                </option>
              `;
            });

            const htmlElement = /*html*/ `
              <div class="row align-items-center justify-content-center">
                <div class="col-md-4 d-flex justify-content-center align-items-center">
                    <div class="input-box w-100">
                        <input
                          class="input-box__input ajax__edit gl__name"
                          type="text"
                          placeholder="Nom"
                          id="types__name--${data.id}"
                          data-id="${data.id}"
                          data-table="${data.table}"
                          data-fieldname="name"
                          data-name="${data.name}"
                          value="${data.name}"
                        >
                        <label class="input-box__label" for="types__name--${data.id}">Nom</label>
                    </div>
                </div>

                <div class="col-md-2 d-flex justify-content-center align-items-center">
                    <div class="input-box input-box--color">
                        <input
                          class="input-box__input ajax__edit gl__color"
                          type="text"
                          placeholder="Couleur"
                          id="types__color--${data.id}"
                          data-id="${data.id}"
                          data-table="${data.table}"
                          data-fieldname="color"
                          data-name="${data.name}"
                          data-color="${data.color}"
                          value="${data.color}"
                        >
                        <label class="input-box__label" for="types__color">Couleur</label>
                        <span class="input-box__color" style="--background-color:${data.color};"></span>
                    </div>
                </div>

                <div class="col-md-4 d-flex justify-content-center align-items-center">
                  <div class="select-box w-100">
                      <select
                        name="category"
                        id="types__category--${data.id}"
                        class="select-box__select ajax__edit gl__category"
                        data-id="${data.id}"
                        data-table="${data.table}"
                        data-fieldname="category_id"
                      >
                        ${categorySelectElement}
                      </select>
                      <label class="select-box__label" for="types__category--${data.id}">Catégorie</label>
                  </div>
                </div>

                <div class="col-md-2 d-flex justify-content-center align-items-center">
                    <a class="gl__action gl__action--delete"
                      data-id="${data.id}"
                      data-name="${data.name}"
                      data-table="${data.table}"
                      data-prefix="${variables.prefix}" href="#"></a>
                </div>
            </div>
            `;
            container.insertAdjacentHTML('beforebegin', htmlElement);

            const inputsAdded = document.querySelectorAll(`#types__name--${data.id}, #types__color--${data.id}, #types__category--${data.id}`);
            !!inputsAdded.length && fieldEdit(inputsAdded);

            const deleteBtnAdded = document.querySelectorAll(`.gl__action--delete[data-id="${data.id}"][data-table="${data.table}"]`);
            !!deleteBtnAdded.length && fieldDelete(deleteBtnAdded);

            const selectAdded = document.querySelector(`#types__category--${data.id}`);
            !!selectAdded && new Choices(selectAdded, variables.choicesOptions);
          }
        } else if (data.table === `${variables.prefix}gl_entities`) {
          const container = document.querySelector("#entities__container");
          if (container) {
            let typeSelect = ``;
            !!data.types.length && [...data.types].forEach(types => {
              typeSelect += /*html*/ `
                <option
                  value="${types.name}"
                  data-typeid="${types.id}"
                  ${types.id === data.type_id ? 'selected="selected"' : ''}
                  ${types.id === data.secondary_type_id ? 'disabled="disabled"' : ''}
                >
                  ${types.name}
                </option>
              `;
            });

            let secondaryTypeSelect = ``;
            !!data.types.length && [...data.types].forEach(types => {
              secondaryTypeSelect += /*html*/ `
                <option
                  value="${types.name}"
                  data-typeid="${types.id}"
                  ${types.id === data.secondary_type_id ? 'selected="selected"' : ''}
                  ${types.id === data.type_id ? 'disabled="disabled"' : ''}
                >
                  ${types.name}
                </option>
              `;
            });

            const htmlElement = /*html*/ `
              <div id="section__entity--${data.id}" class="row section__entity">
                <div class="col">
                    <div class="row m-0 entity__toggle">
                      <div class="col-1">
                        <div class="entity__id">${data.id}</div>
                      </div>
                      <div class="col-4">
                        <div class="input-box">
                          <input
                            type="text"
                            id="entity__name--${data.id}"
                            class="input-box__input ajax__edit gl__name"
                            data-id="${data.id}"
                            data-table="${data.table}"
                            data-fieldname="name"
                            value="${data.name}"
                            placeholder="Nom"
                          >
                          <label class="input-box__label" for="entity__name--${data.id}">Nom</label>
                        </div>
                      </div>
                      <div class="col-9 d-flex justify-content-end align-items-center">
                        <div class="toggle__title"></div>
                        <div class="entity__delete">
                          <a
                            class="gl__action gl__action--delete"
                            data-id="${data.id}"
                            data-name="${data.name}"
                            data-table="${data.table}"
                            data-prefix="${variables.prefix}"
                            href="#"
                          ></a>
                        </div>
                      </div>
                    </div>
                    <div class="row m-0 entity__wrapper py-4">
                        <div class="col-md-6">
                            <div class="row no-gutters entity__infos mb-3">
                                <div class="col-7">
                                    <div class="select-box">
                                        <select id="entity__type--${data.id}"
                                          data-id="${data.id}"
                                          data-table="${data.table}"
                                          data-fieldname="type_id"
                                          class="select-box__select ajax__edit gl__type primary__type"
                                        >
                                          ${typeSelect}
                                        </select>
                                        <label class="select-box__label" for="entity__type--${data.id}">Type</label>
                                    </div>
                                </div>
                                <div class="col-7">
                                    <div class="select-box">
                                        <select
                                          id="entity__secondaryType--${data.id}"
                                          data-id="${data.id}"
                                          data-table="${data.table}"
                                          data-fieldname="secondary_type_id"
                                          class="select-box__select ajax__edit gl__type secondary__type"
                                        >
                                          <option value="0">Aucun</option>
                                          ${secondaryTypeSelect}
                                        </select>
                                        <label class="select-box__label" for="entity__secondaryType--${data.id}">Type secondaire</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row no-gutters entity__location mb-3">
                                <div class="col-14">
                                    <div class="input-box">
                                        <input
                                        type="text"
                                        placeholder="Adresse"
                                        id="entity__address--${data.id}"
                                        data-id="${data.id}"
                                        data-table="${data.table}"
                                        data-fieldname="address"
                                        class="input-box__input ajax__edit gl__address"
                                        value="${data.address}">
                                        <label class="input-box__label" for="entity__address--${data.id}">Adresse</label>
                                    </div>
                                </div>
                                <div class="col-7">
                                    <div class="input-box">
                                        <input
                                          type="text"
                                          placeholder="Latitude"
                                          id="entity__latitude--${data.id}"
                                          data-id="${data.id}"
                                          data-table="${data.table}"
                                          data-fieldname="latitude"
                                          class="input-box__input ajax__edit gl__latitude"
                                          value="${data.latitude}"
                                        >
                                        <label class="input-box__label" for="entity__latitude--${data.id}">Latitude</label>
                                    </div>
                                </div>
                                <div class="col-7">
                                    <div class="input-box">
                                        <input
                                          type="text"
                                          placeholder="Longitude"
                                          id="entity__longitude--${data.id}"
                                          data-id="${data.id}"
                                          data-table="${data.table}"
                                          data-fieldname="longitude"
                                          class="input-box__input ajax__edit gl__longitude"
                                          value="${data.longitude}"
                                        >
                                        <label class="input-box__label" for="entity__longitude--${data.id}">Longitude</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row no-gutters entity__infos">
                                <div class="col-7">
                                    <div class="input-box">
                                        <input
                                          type="text"
                                          placeholder="Téléphone"
                                          id="entity__phone--${data.id}"
                                          data-id="${data.id}"
                                          data-table="${data.table}"
                                          data-fieldname="phone"
                                          class="input-box__input ajax__edit gl__phone"
                                          value="${data.phone}"
                                        >
                                        <label class="input-box__label" for="entity__phone--${data.id}">Téléphone</label>
                                    </div>
                                </div>
                                <div class="col-7">
                                    <div class="input-box">
                                        <input
                                        type="text"
                                        placeholder="Site web"
                                        id="entity__website--${data.id}"
                                        data-id="${data.id}"
                                        data-table="${data.table}"
                                        data-fieldname="website"
                                        class="input-box__input ajax__edit gl__website"
                                        value="${data.website}"
                                        >
                                        <label class="input-box__label" for="entity__website--${data.id}">Site web</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="entity__location">
                                <div class="entity__map" id="map__container--${data.id}"></div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="entity__schedule">
                                <div class="input-box">
                                    <input
                                      type="text"
                                      placeholder="Lundi"
                                      id="entity__monday--${data.id}"
                                      data-id="${data.id}"
                                      data-table="${data.table_schedules}"
                                      data-fieldname="monday"
                                      class="input-box__input ajax__edit gl__schedule"
                                      value="${data.monday}"
                                    >
                                    <label class="input-box__label" for="entity__monday--${data.id}">Lundi</label>
                                </div>
                                <div class="input-box">
                                    <input
                                      type="text"
                                      placeholder="Mardi"
                                      id="entity__tuesday--${data.id}"
                                      data-id="${data.id}"
                                      data-table="${data.table_schedules}"
                                      data-fieldname="tuesday"
                                      class="input-box__input ajax__edit gl__schedule"
                                      value="${data.tuesday}"
                                    >
                                    <label class="input-box__label" for="entity__tuesday--${data.id}">Mardi</label>
                                </div>
                                <div class="input-box">
                                    <input
                                      type="text"
                                      placeholder="Mercredi"
                                      id="entity__wednesday--${data.id}"
                                      data-id="${data.id}"
                                      data-table="${data.table_schedules}"
                                      data-fieldname="wednesday"
                                      class="input-box__input ajax__edit gl__schedule"
                                      value="${data.wednesday}"
                                    >
                                    <label class="input-box__label" for="entity__wednesday--${data.id}">Mercredi</label>
                                </div>
                                <div class="input-box">
                                    <input
                                      type="text"
                                      placeholder="Jeudi"
                                      id="entity__thursday--${data.id}"
                                      data-id="${data.id}"
                                      data-table="${data.table_schedules}"
                                      data-fieldname="thursday"
                                      class="input-box__input ajax__edit gl__schedule"
                                      value="${data.thursday}"
                                    >
                                    <label class="input-box__label" for="entity__thursday--${data.id}">Jeudi</label>
                                </div>
                                <div class="input-box">
                                    <input
                                      type="text"
                                      placeholder="Vendredi"
                                      id="entity__friday--${data.id}"
                                      data-id="${data.id}"
                                      data-table="${data.table_schedules}"
                                      data-fieldname="friday"
                                      class="input-box__input ajax__edit gl__schedule"
                                      value="${data.friday}"
                                    >
                                    <label class="input-box__label" for="entity__friday--${data.id}">Vendredi</label>
                                </div>
                                <div class="input-box">
                                    <input
                                      type="text"
                                      placeholder="Samedi"
                                      id="entity__saturday--${data.id}"
                                      data-id="${data.id}"
                                      data-table="${data.table_schedules}"
                                      data-fieldname="saturday"
                                      class="input-box__input ajax__edit gl__schedule"
                                      value="${data.saturday}"
                                    >
                                    <label class="input-box__label" for="entity__saturday--${data.id}">Samedi</label>
                                </div>
                                <div class="input-box">
                                    <input
                                      type="text"
                                      placeholder="Dimanche"
                                      id="entity__sunday--${data.id}"
                                      data-id="${data.id}"
                                      data-table="${data.table_schedules}"
                                      data-fieldname="sunday"
                                      class="input-box__input ajax__edit gl__schedule"
                                      value="${data.sunday}"
                                    >
                                    <label class="input-box__label" for="entity__sunday--${data.id}">Dimanche</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            `;
            container.insertAdjacentHTML('beforeend', htmlElement);

            setTimeout(() => {
              const inputsAdded = document.querySelectorAll(`
                #entity__name--${data.id},
                #entity__type--${data.id},
                #entity__secondaryType--${data.id},
                #entity__address--${data.id},
                #entity__latitude--${data.id},
                #entity__longitude--${data.id},
                #entity__phone--${data.id},
                #entity__website--${data.id},
                #entity__monday--${data.id},
                #entity__tuesday--${data.id},
                #entity__wednesday--${data.id},
                #entity__thursday--${data.id},
                #entity__friday--${data.id},
                #entity__saturday--${data.id},
                #entity__sunday--${data.id}
              `);
              !!inputsAdded.length && fieldEdit(inputsAdded);

            }, 1000);

            const deleteBtnAdded = document.querySelectorAll(`.gl__action--delete[data-id="${data.id}"][data-table="${data.table}"]`);
            !!deleteBtnAdded.length && fieldDelete(deleteBtnAdded);

            const sectionAdded = document.querySelectorAll(`#section__entity--${data.id}`);
            !!sectionAdded.length && toggleEntities(sectionAdded);
          }
        } else if (data.table === `${variables.prefix}gl_options`) {
          const container = document.querySelector("#form-create-subategories");
          if (container) {
            const htmlElement = /*html*/ `
              <div class="row align-items-center justify-content-center data_source--options">
                <div class="col-md-4 d-flex justify-content-center align-items-center">
                    <div class="input-box w-100">
                        <input
                            type="text"
                            placeholder="Nom"
                            id="options_subcategory__name--${data.id}"
                            class="input-box__input ajax__edit ajax__edit--options ajax__edit--options-subcategory"
                            data-id="1"
                            data-counter="${data.id}"
                            data-table="${data.table}"
                            data-fieldname="post_type_subcategory"
                            data-subfieldname="name"
                            data-name="${data.name}"
                            value="${data.name}"
                        >
                        <label class="input-box__label" for="options_subcategory__name--${data.id}">Nom</label>
                    </div>
                </div>

                <div class="col-md-2 d-flex justify-content-center align-items-center">
                    <div class="input-box input-box--color">
                        <input
                            type="text"
                            placeholder="Couleur"
                            id="options_subcategory__color--${data.id}"
                            class="input-box__input ajax__edit ajax__edit--options ajax__edit--options-subcategory"
                            data-id="1"
                            data-counter="${data.id}"
                            data-table="${data.table}"
                            data-fieldname="post_type_subcategory"
                            data-subfieldname="color"
                            data-name="${data.name}"
                            data-color="${data.color}"
                            value="${data.color}"
                        >
                        <label class="input-box__label" for="options_subcategory__color--${data.id}">Couleur</label>
                        <span class="input-box__color" style="--background-color:${data.color};"></span>
                    </div>
                </div>

                <div class="col-md-2 d-flex justify-content-center align-items-center">
                    <a class="gl__action gl__action--delete"
                        data-id="1"
                        data-counter="${data.id}"
                        data-name="${data.name}"
                        data-table="${data.table}"
                        data-prefix="${variables.prefix}" href="#"></a>
                </div>
              </div>
            `;
            container.insertAdjacentHTML('beforebegin', htmlElement);

            const inputsAdded = document.querySelectorAll(`#options_subcategory__name--${data.id}, #options_subcategory__color--${data.id}`);
            !!inputsAdded.length && fieldEdit(inputsAdded);

            const deleteBtnAdded = document.querySelectorAll(`.gl__action--delete[data-counter="${data.id}"][data-table="${data.table}"]`);
            !!deleteBtnAdded.length && fieldDelete(deleteBtnAdded);
          }
        }
      } else {
        notyf.error('Error in field insertion');
      }
    } else {
      notyf.error('Field already exist');
    }
  }

  /*------------ [AJAX] error------------*/
  const error = (err) => {
    cl(err);
  }

  const forms = document.querySelectorAll(".ajax__create--form");
  !!forms.length && [...forms].forEach(form => {
    const params = {};
    params.action = action;
    params.table = !!form.dataset.table ? form.dataset.table : null;

    const submitBtn = form.querySelector(".ajax__create--submit");
    !!submitBtn && submitBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const inputs = form.querySelectorAll('.ajax__create--value');
      !!inputs.length && [...inputs].forEach(input => {
        const name = input.name;
        const value = input.value;
        params[name] = value;
      });

      ajax(params, success, error, 'json');
    });
  });
}

export { fieldCreateUtilities, fieldCreate }
